export default {
    prompt:"What color is the text background?",
    field:"--textContBackground",
    type:"style",
    colorPicker:true,
    default:"#ffffff00"
}